import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Result } from 'antd';
import type { UserRole } from './roleTypes';
import { hasMinimumRole } from './roleTypes';
import { useAuth } from './AuthContext';

type RoleGateProps = {
    minRole: UserRole;
    children: React.ReactNode;
};

/**
 * Wraps a single route element; shows 403-style result if the user lacks privilege.
 */
export function RoleGate({ minRole, children }: RoleGateProps) {
    const { role } = useAuth();

    if (!hasMinimumRole(role, minRole)) {
        return (
            <Result
                status="403"
                title="Insufficient permissions"
                subTitle={`This area requires at least the "${minRole}" role.`}
                extra={
                    <Link to="/">
                        <Button type="primary">Back to home</Button>
                    </Link>
                }
            />
        );
    }

    return <>{children}</>;
}
